import React from 'react';
import translate from '../../i18n/translate';
import { ADDRESSES } from '../../lib/contracts';

const ETHERSCAN = 'https://sepolia.etherscan.io/address/';
const GITHUB    = 'https://github.com/JVMart/metha';

const CONTRACTS = [
  { addr: ADDRESSES.MethaToken,        nameKey: 'transparency-contract-token',      desKey: 'transparency-contract-token-des' },
  { addr: ADDRESSES.MethaCrowdsale,    nameKey: 'transparency-contract-crowdsale',  desKey: 'transparency-contract-crowdsale-des' },
  { addr: ADDRESSES.AuditingPool,      nameKey: 'transparency-contract-auditing',   desKey: 'transparency-contract-auditing-des' },
  { addr: ADDRESSES.AuditorRegistryV2, nameKey: 'transparency-contract-registry',   desKey: 'transparency-contract-registry-des' },
  { addr: ADDRESSES.OpenGovernance,    nameKey: 'transparency-contract-governance', desKey: 'transparency-contract-governance-des' },
  { addr: ADDRESSES.EternalStorage,    nameKey: 'transparency-contract-storage',    desKey: 'transparency-contract-storage-des' },
];

function shortAddr(a) {
  return a.slice(0, 6) + '…' + a.slice(-4);
}

/**
 * Verify — the receipts. Lists the six deployed v3 contracts on Sepolia,
 * each linked to Etherscan, plus the four trust badges (50+ tests, Slither,
 * MIT, Sepolia testnet). Copy from transparency-* i18n keys.
 *
 * This is the section that turns the narrative into something the visitor
 * can independently audit. Critical for the "trust the code, not the
 * institution" claim.
 */
export default function Verify() {
  return (
    <section className="lv2-section lv2-section--verify" id="verify" style={{ paddingTop: 0 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('transparency-ticker')}</span>
          <h2>{translate('transparency-title')}</h2>
          <p className="sub">{translate('transparency-sub')}</p>
        </div>

        <div className="lv2-verify-grid">
          {CONTRACTS.map(c => (
            <a
              key={c.addr}
              href={ETHERSCAN + c.addr}
              target="_blank"
              rel="noopener noreferrer"
              className="lv2-verify-card"
            >
              <span className="lv2-verify-name">{translate(c.nameKey)}</span>
              <span className="lv2-verify-addr">{shortAddr(c.addr)}</span>
              <span className="lv2-verify-des">{translate(c.desKey)}</span>
              <span className="lv2-verify-cta">View on Etherscan ↗</span>
            </a>
          ))}
        </div>

        <div className="lv2-verify-badges">
          <span className="lv2-badge"><span className="lv2-badge-tick">✓</span>{translate('transparency-badge-tests')}</span>
          <span className="lv2-badge"><span className="lv2-badge-tick">✓</span>{translate('transparency-badge-slither')}</span>
          <span className="lv2-badge"><span className="lv2-badge-tick">✓</span>{translate('transparency-badge-license')}</span>
          <span className="lv2-badge"><span className="lv2-badge-tick">✓</span>{translate('transparency-badge-network')}</span>
          <a className="lv2-badge lv2-badge--link" href={GITHUB} target="_blank" rel="noopener noreferrer">
            <span className="lv2-badge-tick">✓</span>Open source on GitHub ↗
          </a>
        </div>
      </div>
    </section>
  );
}
